export const targetLangSelector = (state) => state.translate.targetLang;
export const originalBlocksSelector = (state) => state.translate.originalBlocks;
export const originalTextsSelector = (state) => state.translate.originalTexts;
